import React from 'react'
import Edit from '../Components/Profile/Edit'
import AnimatedPage from '../AnimatedPage'

const EditProfile = () => {
  return (
    <AnimatedPage>    
      <Edit />
      </AnimatedPage>

  )
}

export default EditProfile